import { Component, Input } from '@angular/core';

/**
 * A rounded rectangle in the style of a Slite hint with a hint icon.
 */

export type HintType = 'information' | 'warning' | 'error';
@Component({
    selector: 'ca-hint',
    templateUrl: 'hint.component.html',
    styleUrls: ['hint.component.scss'],
    standalone: false
})
export class CaHintComponent {
  @Input()
  iconName?: string = 'information';

  @Input()
  type: HintType = 'information';
}
